import "./App.css";
import Routes from "../src/Components/Routes/Routes";

function App() {
  return (
    <div>
      <Routes />
    </div>
  );
}

export default App;
